import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { nanoid } from "nanoid";
import { useCombobox } from "downshift";
import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
/*
	// ${(p) => (p.$isSelected ? "bg-grayscale-lighter" : "")}
	// ${(p) => (p.$isFocused ? "bg-grayscale-lighter" : "bg-grayscale-dark")}
	// ${(p) => (p.Disabled ? "text-[#686a6c]" : "text-white")}}
*/ // 	${(p) => (p.$isSelected ? "bg-grayscale-light" : "bg-grayscale-dark")}
export const DS2Item = tw.li`
	cursor-pointer
	bg-opacity-50
	bg-grayscale-light
	${(p)=>p.$isSelected ? "bg-opacity-90" : "bg-opacity-50"}
	${(p)=>p.$isFocused ? "bg-opacity-100" : ""}

	py-2
	px-3

	text-white
 ${(p)=>p.$isDisabled ? "opacity-50" : ""}
`;
export const Input = tw.input`
	appearance-none
	shadow-none
	rounded-md
	border
	border-white
	border-opacity-10
	focus:outline-0
	focus:border-solid
	focus:border-opacity-25
	hover:border-opacity-25
  !bg-grayscale-light
	py-2
	px-3

	h-10

	w-full !max-w-[375px]
	text-white

	cursor-pointer
`;
// const dropdownSelectStyles = {
// 	position: "absolute",
// 	top: "100%",
// 	zIndex: 20,
// 	overflow: "hidden",
// 	boxSizing: "border-box",
// 	backgroundColor: "#23272E",
// 	paddingTop: "0px!important",
// 	margin: "5px 0",
// 	width: "auto",
// 	minWidth: "200px",
// 	maxWidth: "600px",
// 	cursor: "pointer",
// 	borderRadius: "0.375rem",
// 	borderStyle: "solid",
// 	borderWidth: "1px",
// 	borderColor: "rgba(255, 255, 255, 0.07)",
// 	boxShadow: "0 0px 6px 0 rgba(0,0,0,0.25)",
// }
const MenuStyles = `
	absolute
	max-h-40
	overflow-y-auto
	overflow-x-hidden
	mt-1
	py-1


	bg-grayscale-dark

	shadow-none
	rounded-md
	border
	border-white
  w-auto
	border-opacity-10

	overflow-scroll

	text-white

	divide-y
	divide-solid
	divide-white
	divide-opacity-10

`;
export const Menu = /*#__PURE__*/ React.forwardRef(({ children, ...props }, ref)=>{
    return /*#__PURE__*/ _jsx("ul", {
        ref: ref,
        style: {
            zIndex: 500
        },
        className: `
			${MenuStyles}
			${props.$isOpen ? "" : "hidden"}
		`,
        ...props,
        children: children
    });
});
Menu.displayName = "Menu";
export const ControllerButton = tw.button`
	bg-transparent
	border-none
	absolute
	right-4
	cursor-pointer
	top-3
`;
function ArrowIcon({ isOpen }) {
    return /*#__PURE__*/ _jsx("svg", {
        viewBox: "0 0 20 20",
        preserveAspectRatio: "none",
        width: 16,
        fill: "transparent",
        stroke: "#979797",
        strokeWidth: "1.1px",
        transform: isOpen ? "rotate(180)" : undefined,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1,6 L10,15 L19,6"
        })
    });
}
function ArrowIcon2({ isOpen }) {
    return /*#__PURE__*/ _jsx("svg", {
        width: 16,
        transform: isOpen ? "rotate(180)" : undefined,
        fill: "rgba(255, 255, 255, 0.2)",
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        })
    });
}
function XIcon() {
    return /*#__PURE__*/ _jsxs("svg", {
        viewBox: "0 0 20 20",
        preserveAspectRatio: "none",
        width: 12,
        fill: "transparent",
        stroke: "#757679",
        strokeWidth: "2.1px",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M1,1 L19,19"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19,1 L1,19"
            })
        ]
    });
}
// const ExampleDownshift = ({}: {items: any[], rest: Downshift['props']}) => {
export const SDropdownSelectV2 = ({ itemToString, items: _items, renderItem, disallowEmpty, ...rest })=>{
    const [inputId] = useState(nanoid());
    const [items, setItems] = useState(_items);
    const [shouldBlurInput, setShouldBlurInput] = useState(false);
    // @ts-ignore
    const stateReducer = React.useCallback((state, actionAndChanges)=>{
        const { type, changes } = actionAndChanges;
        console.log(`[!] stateReducer`, type, changes, state);
        // returning an uppercased version of the item string.
        switch(type){
            case useCombobox.stateChangeTypes.InputChange:
                let setHightlightedIndex = undefined;
                // Once we start typing, let's figure out if we don't have a
                // highlightedIndex, and if we don't, let's set it to 0.
                if (changes.inputValue.length > 0) {
                    if (changes.highlightedIndex === -1) {
                        setHightlightedIndex = 0;
                    }
                }
                console.log(`[!] stateReducer - InputChange`, changes.inputValue, setHightlightedIndex);
                return {
                    // return normal changes.
                    ...changes,
                    ...typeof setHightlightedIndex != "undefined" ? {
                        highlightedIndex: setHightlightedIndex
                    } : {},
                    // but taking the change from default reducer and uppercasing it.
                    inputValue: changes.inputValue
                };
            // also on selection.
            case useCombobox.stateChangeTypes.ItemClick:
            case useCombobox.stateChangeTypes.InputKeyDownEnter:
                // Hack: Not sure how to best express this side effect...
                // Set this value, which we consume in a useEffect to blur the input.
                setShouldBlurInput(true);
                return {
                    ...changes,
                    // if we had an item selected.
                    ...changes.selectedItem && {
                        // we will show it uppercased.
                        inputValue: changes.inputValue
                    }
                };
            case useCombobox.stateChangeTypes.InputBlur:
                return {
                    ...changes,
                    // if we had an item selected.
                    ...changes.selectedItem && {
                        // we will show it uppercased.
                        inputValue: itemToString(changes.selectedItem)
                    }
                };
            case useCombobox.stateChangeTypes.InputClick:
                return {
                    ...changes,
                    // if we had an item selected.
                    ...changes.selectedItem && {
                        // we will show it uppercased.
                        inputValue: ""
                    }
                };
            default:
                return changes // otherwise business as usual.
                ;
        }
    }, []);
    // Try to blur the selection on click or enter
    useEffect(()=>{
        if (shouldBlurInput) {
            setShouldBlurInput(false);
            const inputElement = document.getElementById(inputId);
            if (inputElement && inputElement === document.activeElement) {
                inputElement.blur();
            }
        }
    }, [
        shouldBlurInput
    ]);
    const loggedReducer = (reducer)=>{
        return (state, action)=>{
            const newState = reducer(state, action);
            return newState;
        };
    };
    const { selectItem, getInputProps, getToggleButtonProps, getMenuProps, getItemProps, isOpen, selectedItem, highlightedIndex } = useCombobox({
        selectedItem: rest.selectedItem,
        onSelectedItemChange: (change)=>{
            if (rest.onChange) {
                rest.onChange(change.selectedItem || null, change);
            }
        },
        items,
        itemToString,
        onInputValueChange: ({ inputValue })=>{
            setItems(_items.filter((item)=>itemToString(item).toLowerCase().includes(inputValue?.toLowerCase() || "")));
        },
        stateReducer: loggedReducer(stateReducer)
    });
    console.log(`input props`, getInputProps({}));
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ _jsx(Input, {
                        ...getInputProps({
                            id: inputId,
                            isOpen,
                            placeholder: selectedItem ? itemToString(selectedItem) : "Select..."
                        })
                    }),
                    selectedItem && !disallowEmpty ? /*#__PURE__*/ _jsx(ControllerButton, {
                        style: {
                            marginTop: "2px"
                        },
                        onClick: ()=>{
                            selectItem(null);
                        },
                        "aria-label": "clear selection",
                        children: /*#__PURE__*/ _jsx(XIcon, {})
                    }) : /*#__PURE__*/ _jsx(ControllerButton, {
                        ...getToggleButtonProps(),
                        style: {
                            marginTop: "1px"
                        },
                        children: /*#__PURE__*/ _jsx(ArrowIcon2, {
                            isOpen: isOpen
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Menu, {
                ...getMenuProps({
                    $isOpen: isOpen
                }),
                children: [
                    items.length === 0 ? /*#__PURE__*/ _jsx(DS2Item, {
                        $isDisabled: true,
                        children: "No results"
                    }) : null,
                    items.map((item, index)=>/*#__PURE__*/ _jsx(DS2Item, {
                            $isFocused: highlightedIndex === index,
                            $isSelected: selectedItem === item,
                            ...getItemProps({
                                item,
                                index
                            }),
                            children: renderItem ? renderItem(item) : itemToString(item)
                        }, item?.id || itemToString(item)))
                ]
            })
        ]
    });
};
SDropdownSelectV2.displayName = "ExampleDownshift";
